// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mgmt-page {
  min-height: 100vh;
  padding: 70px 20px 28px;
  background: #f6f8fb;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
}

.mgmt-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 0 0 16px;
  width: 100%;
  flex-wrap: wrap;
}

.mgmt-page-header h2,
.mgmt-page-header .headS {
  margin: 0;
  font-size: 25px !important;
  line-height: 1.25;
  font-weight: 700;
  color: #0f172a;
}

.mgmt-page-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.mgmt-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

/* Single search field — no double border */
.mgmt-search {
  width: 180px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #ffffff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}

.mgmt-search .form-control,
.mgmt-search input {
  width: 100%;
  height: 100%;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 10px !important;
  font-size: 13px;
  border-radius: 6px;
}

.mgmt-search .input-group,
.mgmt-search .actual-search-wrapper-input {
  width: 100%;
  height: 100%;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.mgmt-icon-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #79c6e9;
  color: #000000 !important;
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 6px;
  flex-shrink: 0;
}

.mgmt-icon-btn svg,
.mgmt-icon-btn * {
  color: #000000 !important;
  /* fill: currentColor; */
}

.mgmt-upload-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000000 !important;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.mgmt-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  padding: 12px;
  box-sizing: border-box;
}

.mgmt-loading {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mgmt-table {
  width: 100% !important;
  border-collapse: collapse;
}

.mgmt-pagination {
  width: 100%;
  margin: 14px 0 0;
  display: flex;
  justify-content: flex-end;
}

.mgmt-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mgmt-filter label {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
  white-space: nowrap;
}

.mgmt-date-input {
  height: 34px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  outline: none;
}

.mgmt-count-plain {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #0f172a;
  font-weight: 600;
  white-space: nowrap;
  border: none;
  background: transparent;
  padding: 0;
}

.print-request-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 16px;
}

.mgmt-empty {
  grid-column: 1 / -1;
  padding: 48px 20px;
  color: #64748b;
  text-align: center;
}

@media (max-width: 800px) {
  .mgmt-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .mgmt-page-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .mgmt-actions {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/ManagementPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;EACjB;AACF","sourcesContent":[".mgmt-page {\r\n  min-height: 100vh;\r\n  padding: 70px 20px 28px;\r\n  background: #f6f8fb;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.mgmt-page-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin: 0 0 16px;\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.mgmt-page-header h2,\r\n.mgmt-page-header .headS {\r\n  margin: 0;\r\n  font-size: 25px !important;\r\n  line-height: 1.25;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n}\r\n\r\n.mgmt-page-header p {\r\n  margin: 4px 0 0;\r\n  color: #64748b;\r\n  font-size: 13px;\r\n}\r\n\r\n.mgmt-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Single search field — no double border */\r\n.mgmt-search {\r\n  width: 180px;\r\n  height: 36px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #ffffff;\r\n  display: flex;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n}\r\n\r\n.mgmt-search .form-control,\r\n.mgmt-search input {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none !important;\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n  background: transparent !important;\r\n  padding: 0 10px !important;\r\n  font-size: 13px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.mgmt-search .input-group,\r\n.mgmt-search .actual-search-wrapper-input {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  background: transparent !important;\r\n}\r\n\r\n.mgmt-icon-btn {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #79c6e9;\r\n  color: #000000 !important;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  border-radius: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mgmt-icon-btn svg,\r\n.mgmt-icon-btn * {\r\n  color: #000000 !important;\r\n  /* fill: currentColor; */\r\n}\r\n\r\n.mgmt-upload-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #000000 !important;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.mgmt-card {\r\n  width: 100%;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\r\n  padding: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.mgmt-loading {\r\n  min-height: 360px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.mgmt-table {\r\n  width: 100% !important;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.mgmt-pagination {\r\n  width: 100%;\r\n  margin: 14px 0 0;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mgmt-filter {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.mgmt-filter label {\r\n  font-size: 13px;\r\n  color: #475569;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mgmt-date-input {\r\n  height: 34px;\r\n  padding: 0 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #ffffff;\r\n  color: #334155;\r\n  outline: none;\r\n}\r\n\r\n.mgmt-count-plain {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 14px;\r\n  color: #0f172a;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0;\r\n}\r\n\r\n.print-request-grid {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.mgmt-empty {\r\n  grid-column: 1 / -1;\r\n  padding: 48px 20px;\r\n  color: #64748b;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 800px) {\r\n  .mgmt-page {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n  }\r\n\r\n  .mgmt-page-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .mgmt-actions {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
